
import { CommonModule } from '@angular/common';
import { Injectable, ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DynamicDirectiveModule } from './directive/dynamic-directive.module';
import { DynamicRenderModule } from './dynamic-render/dynamic-render.module';
import { DynamicRenderSharedModule } from './dynamic-render/shared/shared.module';
import { DynamicWorkflowComponent } from './dynamic-workflow.component';
import { LegacyModule } from './legacy/legacy.module';
import { DynamicPipeModule } from './pipe/dynamic-pipe.module';
import { RoutePageComponent } from './route-page/route-page.component';
import { WorkflowWidgetConfigAndRouteService } from './widget/workflow-widget-config-route.service';

@NgModule({
  declarations: [DynamicWorkflowComponent, RoutePageComponent],
  imports: [
    CommonModule,
    FormsModule,
    DynamicRenderModule,
    RouterModule,
    LegacyModule,
    DynamicPipeModule,
    DynamicDirectiveModule,
    DynamicRenderSharedModule
  ],
  exports: [
    LegacyModule,
    DynamicPipeModule,
    DynamicRenderModule,
    DynamicDirectiveModule,
    DynamicRenderSharedModule,
    DynamicWorkflowComponent
  ],
  providers: [WorkflowWidgetConfigAndRouteService]
})
export class DynamicWorkflowModule {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static withBuildingBlock(components: any[]): ModuleWithProviders<DynamicWorkflowModule> {
    return {
      ngModule: DynamicWorkflowModule,
      providers: [
        {
          provide: DynamicComponentConfigService,
          useFactory: () => {
            const service = new DynamicComponentConfigService();
            service.registerComponents(components);
            return service;
          }
        }
      ]
    };
  }
}

@Injectable({ providedIn: 'root' })
export class DynamicComponentConfigService {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private _components = new Set<any>();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  registerComponents(components: any[]) {
    // eslint-disable-next-line no-underscore-dangle
    components.forEach((comp) => this._components.add(comp));
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get components(): any[] {
    // eslint-disable-next-line no-underscore-dangle
    return Array.from(this._components);
  }
}
